<template>
  <div class="author-message">
    <template v-if="!text && !clicked">
      <greeting
        wave="true"
        boldMessage="Say hi!"
        message="Write a message to readers who have chosen to review your book."
        marginTop="4px"
      ></greeting>
    </template>
    <template v-else>
      <div class="author-heading hidden-md-and-up">Message to Readers</div>
      <div class="author-bar">
        <div class="author-heading hidden-sm-and-down">Message to Readers</div>
        <div class="author-examples" @click="clickExamples">Examples</div>
        <div class="author-save action" @click="clickSave">Save</div>
      </div>
    </template>
    <textarea v-model="text" class="message-text" @input="validateAuthorMessage" @click="clicked = true"></textarea>
    <div class="author-footer">
      <div
      class="author-length"
      :class="{'author-over': text.length > 240}"
      v-if="text"
      >{{ text.length }} of 240 characters</div>
      <div v-if="authorMessagErrorTxt" class="message-error"> {{ authorMessagErrorTxt }}</div>
    </div>
    <div class="author-bottom"></div>
    <div class="author-show-examples" v-if="showExamples">
      Hello, everyone! I’m so excited to share my first novel with you, which was inspired by the rich history and culture of my hometown, New Orleans, Louisiana. I really appreciate your review, thank you!
      <br />
      <br />Greetings! After working in sales for 20 years, I wanted to write a book with concrete, step-by-step strategies for finding new clients, no matter what industry you work in. I hope you find some useful tips, and thanks for your time!
    </div>
  </div>
</template>

<script>
import Back from "@/modules/Back";
import BookStatus from "../../values/BookStatus";
import Greeting from "@/components/Form/Greeting";
import { mapState } from "vuex";

export default {
  name: "Actions",
  props: ["book", "single"],
  components: { Greeting },
  data: function () {
    return {
      text: this.book.author_message,
      showExamples: false,
      clicked: false,
      authorMessagErrorTxt: null,
    };
  },
  computed: {
    ...mapState({
      user: "user"
    }),
    canSave() {
      return this.text !== this.book.author_message;
    },
  },
  methods: {
    async clickSave() {

      this.validateAuthorMessage();
      if (this.authorMessagErrorTxt) {
        return
      }

      const response = await Back.saveAuthorMessage(this.book, this.text);
      if (!response) {
        this.$toasted.show(
          "Oops! Something went wrong. Please try again later.",
          {
            icon: "error",
            position: "bottom-center",
            duration: 2000,
          }
        );
      } else {
        this.$toasted.show("Your message has been saved!", {
          icon: "check_circle",
          position: "bottom-center",
          duration: 20000,
          fullWidth: false,
        });
      }
    },
    validateAuthorMessage() {
      const numStarRegex = /(?:\d|one|two|three|four|five)+.{0,5}(?:🌞|🌟|🌠|st.{0,2}r)/i;
      const starNumRegex = /(?:🌞|🌟|🌠|st.{0,2}r).{0,5}(?:\d|one|two|three|four|five)+/i;
      const emailSearchStr = this.user.email.substring(0,this.user.email.lastIndexOf("."));
      // const emailRegexPattern = new RegExp('(?:' + this.user.email.replaceAll(/[@\\.]/g,').{1,5}(?:') + ')','i')
      const emailRegexPattern = new RegExp('(?:' + emailSearchStr.replaceAll(/[@\\.]/g,').{1,5}(?:') + ')','i')

      if (numStarRegex.test(this.text) || starNumRegex.test(this.text)) {
        this.authorMessagErrorTxt = "Oops! It looks like your message may be trying to request a specific rating. Please remove any language around specific ratings"
      } else if (emailRegexPattern.test(this.text)) {
        this.authorMessagErrorTxt = "Oops! It looks like you might be trying to ask readers to contact you. Please do not ask for direct contact!"
      } else if (this.text.length > 240) {
        this.authorMessagErrorTxt = "Oops! Your message is a little too long. Please shorten it then save again."
      } else {
        this.authorMessagErrorTxt = null
      }
    },
    clickExamples() {
      this.showExamples = !this.showExamples;
    },
  },
  created() {
    // console.log("Actions Book", this.book);
  },
};
</script>

<style scoped lang="scss">
.author-bar {
  display: flex;
  font-family: $font-family;
  margin-top: 1px;
}

.author-bottom {
  display: flex;
  justify-content: center;
}
.author-examples {
  font-size: 11.5pt;
  font-weight: 700;
  font-family: $font-family;
  color: $color-blue;
  border: 2px solid #eee;
  border-radius: 36px;
  padding: 4px 16px;
  margin: 10px 8px 0px 12px;
  margin-left: auto;
}
.author-examples:hover {
  border: 2px solid #ddd;
  cursor: pointer;
}
.author-show-examples {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13pt;
  font-family: $font-family;
}

.author-heading {
  padding: 0.65em 0 0em 0.7em;
  font-size: 15pt;
  font-weight: 600;
  text-align: center;
}
@media (max-width: 1024px) {
  .author-heading {
    padding: 0.65em 0 0.3em 10px;
    font-size: 15pt;
    font-weight: 600;
    text-align: left;
    font-family: $font-family;
  }
}
.author-save {
  margin-left: auto;
  background: #fff;
  border: 2px solid #eee;
  color: #2196f3;
}

.actions {
  margin-left: 8px;
}

.single {
  margin-left: 0;
  margin-top: 64px !important;
}

.one-action {
  margin-top: 25px;
}

.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.get-reviewed {
  background-color: lighten(#ffe0b2, 8%);
  border: 2px solid #ffe0b2;
  padding: 0.4em 0.7em 0.3em 0.7em;
  color: #f57c00;
}
.edit {
  background: #daedff;
  color: #2196f3;
}

.author-length {
  max-width: 20%;
  float: right;
  font-size: 10.5pt;
  text-align: right;
  font-family: $font-family;
}
.author-over {
  color: red !important;
}
.message-error {
  float:left;
  max-width: 80%;
  color: $color-red;
}

.message-text {
  width: 100%;
  height: 64px;
  margin: 0 auto;
  margin-top: 4px;
  border: 2px solid #f3f3f3;
  border-radius: 8px;
  padding: 6px 12px;
  font-family: $font-family;
  font-size: 13pt;
  outline: none;
}
.author-footer {
  display: float;
  text-align: top;
  margin: 0px;
  padding: 0 10px 0 10px;
}
</style>
